import { create } from 'zustand';

type ThemeMode = 'light' | 'dark';

interface ThemeState {
  mode: ThemeMode;
  toggle: () => void;
  setMode: (mode: ThemeMode) => void;
}

const getInitialMode = (): ThemeMode => {
  const saved = localStorage.getItem('admin_theme');
  if (saved === 'dark' || saved === 'light') return saved;
  if (window.matchMedia?.('(prefers-color-scheme: dark)').matches) return 'dark';
  return 'light';
};

export const useThemeStore = create<ThemeState>((set) => ({
  mode: getInitialMode(),
  toggle: () => set((state) => {
    const next = state.mode === 'light' ? 'dark' : 'light';
    localStorage.setItem('admin_theme', next);
    document.documentElement.setAttribute('data-theme', next);
    return { mode: next };
  }),
  setMode: (mode) => {
    localStorage.setItem('admin_theme', mode);
    document.documentElement.setAttribute('data-theme', mode);
    set({ mode });
  },
}));
